import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core/';

export default function(props){
    const { closeMethod } = props;
    return(
        <IconButton
        aria-label='close'
        onClick={closeMethod}
        style={{ padding: '1px', float: 'right' }}
    >
        <CloseIcon />
    </IconButton>
    )
}